import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Typography } from '@mui/material';
import { useViewContext } from '../../context/ViewContext';
import { MetricTile } from './EnergyUi';

export default function EmsDispatchDialog({ open, onClose, model }) {
  const { setView } = useViewContext();
  const { ems, bess } = model;
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md" aria-labelledby="ems-dispatch-title" aria-describedby="ems-dispatch-description">
      <DialogTitle id="ems-dispatch-title">EMS dispatch logic &amp; constraints</DialogTitle>
      <DialogContent>
        <DialogContentText id="ems-dispatch-description" sx={{ mb: 2 }}>
          Current reported policy and measured response. Dispatch preferences are read-only.
        </DialogContentText>
        <Grid container spacing={1}>
          <Grid item xs={6}><MetricTile label="Mode" value={ems.mode} accent="#00897b" /></Grid>
          <Grid item xs={6}><MetricTile label="Objective" value={ems.objective} accent="#00897b" /></Grid>
          <Grid item xs={12} sm={4}><MetricTile label="Requested" value={ems.requestedKw} unit="kW" accent="#00897b" /></Grid>
          <Grid item xs={12} sm={4}><MetricTile label="Constrained" value={ems.constrainedKw} unit="kW" accent="#ed6c02" /></Grid>
          <Grid item xs={12} sm={4}><MetricTile label="Actual PCS response" value={bess.pcsKw ?? ems.actualKw} unit="kW" accent="#388e3c" /></Grid>
          <Grid item xs={6}><MetricTile label="Binding constraint" value={ems.constraint} /></Grid>
          <Grid item xs={6}><MetricTile label="Acknowledgement" value={ems.acknowledgement} /></Grid>
          <Grid item xs={6}><MetricTile label="Minimum SOC" value={bess.minSocPct} unit="%" /></Grid>
          <Grid item xs={6}><MetricTile label="Maximum SOC" value={bess.maxSocPct} unit="%" /></Grid>
          <Grid item xs={6}><MetricTile label="Demand target" value={ems.demandTargetKw} unit="kW" /></Grid>
          <Grid item xs={6}><MetricTile label="Grid export limit" value={ems.exportLimitKw} unit="kW" /></Grid>
          <Grid item xs={6}><MetricTile label="Available charge" value={bess.availableChargeKw} unit="kW" /></Grid>
          <Grid item xs={6}><MetricTile label="Available discharge" value={bess.availableDischargeKw} unit="kW" /></Grid>
        </Grid>
        <Typography variant="body2" sx={{ mt: 2 }}>Decision rationale: {ems.reason || '-'}</Typography>
        <Typography variant="body2">Authority: {ems.authority || '-'}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => { onClose(); setView('emsView'); }}>Dispatch history</Button>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
